/* ==================================================================
   FRANTIC STUDIO - Free Gift
   ------------------------------------------------------------------
   MODULE MAP - the whole feature, five removable pieces:

     [Shopify Admin]  Discount "FRANTIC GIFT - Free Travel Pouch"
                      makes 1 pouch free at the EUR-200 equivalent.
                      Edit amount/product there. No code involved.
     [Shopify Admin]  Collection "SYSTEM - Gift Eligible" - the
                      discount's purchase requirement.
     [THIS FILE]      The ONLY file that ever writes to the cart.
                      Everything tunable sits in CONFIG below. Set
                      behaviour.addToCart=false to turn it into a
                      pure display layer (toast/pill/promo copy) if
                      the discount itself auto-adds the gift.
     [snippets/frantic-gift-promo.liquid]  all styling.
     [snippets/head-preloader.liquid]      two include lines - the
                      on/off switch. Delete them to remove it all.

   DUPLICATE SAFETY: if anything else ever adds the pouch too (an
   app, Shopify's native gift auto-add, the customer), this script
   never fights it: it re-checks the cart right before adding,
   adopts foreign gift lines instead of adding its own, collapses
   duplicates keeping the DISCOUNTED line, and logs the removed
   line's properties to the console so the culprit is identifiable.

   Sections: 1 CONFIG  2 CURRENCY  3 CART API  4 ICONS  5 TIMING CSS
             6 TOAST  7 CART UI  8 GIFT LINE  9 ENGINE
             10 OBSERVERS  11 PROMO  12 BOOT
   ================================================================== */
(function () {
  'use strict';

  if (window.__franticAutoGift) { return; }
  window.__franticAutoGift = true;

  /* ================================================================
     1. CONFIG
     ================================================================ */
  var CONFIG = {
    enabled: true,

    /* The gift */
    variantId: 51813492523349,          // EMBOSSED Frantic Travel Pouch
    productId: 10239690834261,
    quantity: 1,

    /* Threshold in SHOP currency (EUR), in cents. */
    threshold: 20000,                   // EUR 200.00

    currency: {
      convert: true,                    // false = same number in every currency
      roundUpTo: 500,                   // round converted value up to full 5
      overrides: {}                     // e.g. { USD: 23500 } beats conversion
    },

    behaviour: {
      addToCart: true,                  // false = display only, something else adds
      autoRemove: true,                 // remove again below the threshold
      lockQuantity: true,               // hide the qty stepper on the gift line
      respectManualRemove: true         // don't re-add after a manual removal
    },

    /* Copy. {threshold} becomes the localised amount. */
    text: {
      addedTag: 'Free',
      addedLabel: 'Gift unlocked',
      addedSub: 'Your EMBOSSED Travel Pouch has been added to the cart — on me.',
      removedTag: '{threshold}',
      removedLabel: 'Gift removed',
      removedSub: 'Spend {threshold} or more and the Travel Pouch is yours for free.',
      cartTag: 'Free',
      cartLabel: 'Gift at {threshold}+'
    },

    toast: {
      show: true,
      showOnRemove: true,
      showImage: false,
      duration: 4200,
      position: 'bottom-right'          // bottom-right|bottom-left|bottom-center|top-right|top-center
    },

    promo: {
      enabled: true,
      handle: 'embossed-frantic-travel-pouch',
      label: 'Free on every order over {threshold}',
      freeLabel: 'Free',
      updatePrice: true
    },

    timing: {
      debounce: 40,                     // ms after an observed cart write
      /* FRANTIC 2026-08: war 0, der erste /cart.js-Abruf lag damit mitten im
         LCP-Fenster und konkurrierte mit dem Hero-Bild. Jede echte
         Warenkorb-Aenderung loest ohnehin ueber die fetch-/XHR-Hooks einen
         Sync aus, der Erst-Check darf also warten. */
      boot: 1200,                       // ms before the first check
      preAddCheck: 300,                 // ms re-check window before we add (race guard)
      settle: 900,                      // ms verification pass after our own writes
      animIn: 200,
      animOut: 160
    },

    debug: false
  };

  if (!CONFIG.enabled) { return; }

  /* FRANTIC 2026-10-25: Texte je Sprache.
     Dieses Script ueberschreibt die Promo-Box nach dem Laden und baut Toast
     und Warenkorb-Plakette selbst. Bisher stand dadurch auf /de, /fr und /ar
     alles auf Englisch. Hier werden NUR Texte ersetzt, keine Logik, keine
     Schwelle, kein Warenkorb-Verhalten. {threshold} bleibt Platzhalter.
     Englisch bleibt exakt wie oben in CONFIG. */
  CONFIG.text.close = 'Close';
  var FS_LANG = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var FS_I18N = {
    de: {
      text: {
        addedTag: 'Gratis',
        addedLabel: 'Geschenk freigeschaltet',
        addedSub: 'Dein EMBOSSED Travel Pouch liegt jetzt im Warenkorb. Geht auf mich.',
        removedLabel: 'Geschenk entfernt',
        removedSub: 'Ab {threshold} Bestellwert gehört das Travel Pouch dir, gratis.',
        cartTag: 'Gratis',
        cartLabel: 'Geschenk ab {threshold}',
        close: 'Schließen'
      },
      promo: { label: 'Gratis ab {threshold} Bestellwert', freeLabel: 'Gratis' }
    },
    fr: {
      text: {
        addedTag: 'Offert',
        addedLabel: 'Cadeau débloqué',
        addedSub: 'Votre pochette de voyage EMBOSSED a été ajoutée au panier. C’est offert.',
        removedLabel: 'Cadeau retiré',
        removedSub: 'Dès {threshold} d’achat, la pochette de voyage vous est offerte.',
        cartTag: 'Offert',
        cartLabel: 'Cadeau dès {threshold}',
        close: 'Fermer'
      },
      promo: { label: 'Offert dès {threshold} d’achat', freeLabel: 'Offert' }
    },
    ar: {
      text: {
        addedTag: 'مجاناً',
        addedLabel: 'تم فتح الهدية',
        addedSub: 'تمت إضافة حقيبة السفر EMBOSSED إلى سلتك مجاناً.',
        removedLabel: 'تمت إزالة الهدية',
        removedSub: 'اطلب بقيمة {threshold} أو أكثر واحصل على حقيبة السفر مجاناً.',
        cartTag: 'مجاناً',
        cartLabel: 'هدية عند {threshold} أو أكثر',
        close: 'إغلاق'
      },
      promo: { label: 'مجاناً للطلبات فوق {threshold}', freeLabel: 'مجاناً' }
    }
  };
  (function (t) {
    if (!t) { return; }
    var k;
    for (k in t.text) {
      if (Object.prototype.hasOwnProperty.call(t.text, k)) { CONFIG.text[k] = t.text[k]; }
    }
    for (k in t.promo) {
      if (Object.prototype.hasOwnProperty.call(t.promo, k)) { CONFIG.promo[k] = t.promo[k]; }
    }
  })(FS_I18N[FS_LANG]);

  var ATTR_ADDED = '_frantic_gift';
  var ATTR_DECLINED = '_frantic_gift_declined';
  /* The gift line carries NO line properties, so it can merge with a
     plain customer-added line of the same variant. */

  function log() {
    if (CONFIG.debug && window.console) {
      console.log.apply(console, ['[frantic-gift]'].concat([].slice.call(arguments)));
    }
  }

  /* ================================================================
     2. CURRENCY
     ================================================================ */
  function shopifyCurrency() {
    try {
      if (window.Shopify && window.Shopify.currency) {
        return {
          code: window.Shopify.currency.active || 'EUR',
          rate: parseFloat(window.Shopify.currency.rate) || 1
        };
      }
    } catch (e) {}
    return { code: 'EUR', rate: 1 };
  }

  var MONEY = shopifyCurrency();

  var THRESHOLD = (function () {
    var override = CONFIG.currency.overrides && CONFIG.currency.overrides[MONEY.code];
    if (typeof override === 'number' && override > 0) { return override; }
    if (!CONFIG.currency.convert || !(MONEY.rate > 0) || MONEY.rate === 1) {
      return CONFIG.threshold;
    }
    var step = CONFIG.currency.roundUpTo > 0 ? CONFIG.currency.roundUpTo : 1;
    return Math.ceil((CONFIG.threshold * MONEY.rate) / step) * step;
  })();

  function formatMoney(cents, code) {
    var units = cents / 100;
    try {
      return new Intl.NumberFormat('en', {
        style: 'currency', currency: code,
        minimumFractionDigits: units % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(units);
    } catch (e) {
      return (units % 1 === 0 ? units.toFixed(0) : units.toFixed(2)) + ' ' + code;
    }
  }

  var THRESHOLD_LABEL = formatMoney(THRESHOLD, MONEY.code);

  function fill(str) {
    return String(str).split('{threshold}').join(THRESHOLD_LABEL);
  }

  log('currency', MONEY.code, 'rate', MONEY.rate, 'threshold', THRESHOLD, THRESHOLD_LABEL);

  /* ================================================================
     3. CART API  -  the only write helpers in the whole feature
     ================================================================ */
  var ROOT = (function () {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      var u = window.KROWN && window.KROWN.settings && window.KROWN.settings.routes &&
              window.KROWN.settings.routes.cart_change_url;
      if (u) { return u.replace(/cart\/change.*$/, ''); }
    } catch (e) {}
    return '/';
  })();
  if (ROOT.charAt(ROOT.length - 1) !== '/') { ROOT += '/'; }

  var URL_CART = ROOT + 'cart.js';
  var JSON_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };

  /* fetch captured before our observer wraps window.fetch */
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;

  function post(path, payload) {
    return rawFetch(ROOT + path, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return rawFetch(URL_CART + '?t=' + Date.now(), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function setAttributes(patch) { return post('cart/update.js', { attributes: patch }); }
  function setAttributesAsync(patch) {
    setAttributes(patch).catch(function (e) { log('attr failed', e); });
  }

  /* ================================================================
     4. ICONS (same drawing style as the us-duties notice)
     ================================================================ */
  var ICON_GIFT =
    '<svg class="frantic-gift__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M19.9 12.4v7.3a.8.8 0 0 1-.8.8H4.9a.8.8 0 0 1-.8-.8v-7.3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M20.9 8.2H3.1a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6h17.8a.6.6 0 0 0 .6-.6v-3a.6.6 0 0 0-.6-.6Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M12 8.2v12.3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '<path d="M12 8.2H7.9a2.1 2.1 0 1 1 0-4.2c2.9 0 4.1 4.2 4.1 4.2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M12 8.2h4.1a2.1 2.1 0 1 0 0-4.2C13.2 4 12 8.2 12 8.2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '</svg>';

  var ICON_INFO =
    '<svg class="frantic-gift__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M12 11.2v5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '<path d="M12 7.9h.01" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>' +
    '</svg>';

  /* ================================================================
     5. TIMING CSS (all visual rules: snippets/frantic-gift-promo.liquid)
     ================================================================ */
  function injectStyles() {
    if (document.getElementById('frantic-gift-style')) { return; }
    var s = document.createElement('style');
    s.id = 'frantic-gift-style';
    s.textContent = ':root{--fg-in:' + CONFIG.timing.animIn + 'ms;--fg-out:' + CONFIG.timing.animOut + 'ms}';
    (document.head || document.documentElement).appendChild(s);
  }
  if (document.head || document.documentElement) { injectStyles(); }

  /* ================================================================
     6. TOAST
     ================================================================ */
  var toastHost = null;

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function getToastHost() {
    if (toastHost && document.body && document.body.contains(toastHost)) { return toastHost; }
    if (!document.body) { return null; }
    toastHost = document.createElement('div');
    toastHost.className = 'frantic-gift-toasts';
    toastHost.setAttribute('data-pos', CONFIG.toast.position);
    document.body.appendChild(toastHost);
    return toastHost;
  }

  function showToast(opts) {
    if (!CONFIG.toast.show) { return; }
    injectStyles();
    var host = getToastHost();
    if (!host) { return; }

    var el = document.createElement('div');
    el.className = 'frantic-gift-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    var html = '';
    if (CONFIG.toast.showImage && opts.image) {
      html += '<img class="frantic-gift-toast__img" src="' + escapeHtml(opts.image) + '" alt="" loading="lazy">';
    }
    html += '<span class="frantic-gift-toast__pill">' +
              '<span class="frantic-gift-toast__tag">' + escapeHtml(fill(opts.tag)) + '</span>' +
              (opts.icon || ICON_GIFT) +
              '<span class="frantic-gift-toast__label">' + escapeHtml(fill(opts.label)) + '</span>' +
            '</span>';
    if (opts.sub) {
      html += '<span class="frantic-gift-toast__sub">' + escapeHtml(fill(opts.sub)) + '</span>';
    }
    html += '<button class="frantic-gift-toast__close" type="button" aria-label="' + escapeHtml(CONFIG.text.close || 'Close') + '">' +
              '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
              '<path d="M5 5l14 14M19 5 5 19" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>' +
              '</svg></button>';

    el.innerHTML = html;
    host.appendChild(el);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-in'); });
    });

    var timer = setTimeout(dismiss, CONFIG.toast.duration);
    var closeBtn = el.querySelector('.frantic-gift-toast__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { clearTimeout(timer); dismiss(); });
    }
    function dismiss() {
      el.classList.remove('is-in');
      el.classList.add('is-out');
      setTimeout(function () {
        if (el.parentNode) { el.parentNode.removeChild(el); }
      }, CONFIG.timing.animOut + 40);
    }
  }

  function toastAdded(image) {
    try {
      showToast({ tag: CONFIG.text.addedTag, label: CONFIG.text.addedLabel,
                  sub: CONFIG.text.addedSub, icon: ICON_GIFT, image: image });
    } catch (e) { log('toast failed', e); }
  }
  function toastRemoved(image) {
    if (!CONFIG.toast.showOnRemove) { return; }
    try {
      showToast({ tag: CONFIG.text.removedTag, label: CONFIG.text.removedLabel,
                  sub: CONFIG.text.removedSub, icon: ICON_INFO, image: image });
    } catch (e) { log('toast failed', e); }
  }

  /* ================================================================
     7. CART UI refresh (theme's own renderer)
     ================================================================ */
  function refreshCartUI() {
    if (!document.getElementById('AjaxCartForm')) { return Promise.resolve(); }
    return rawFetch('?section_id=helper-cart', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        if (typeof window.renderHelperCart === 'function') { window.renderHelperCart(text); }
        var rec = document.querySelector('cart-recommendations');
        if (rec && typeof rec.generateRecommendations === 'function') {
          rec.innerHTML = '';
          rec.generateRecommendations();
        }
      })
      .catch(function (e) { log('refresh failed', e); });
  }

  /* ================================================================
     8. GIFT LINE decoration (pill + quantity lock)
     ================================================================ */
  var giftKey = null;

  function clearFlag(item) {
    item.classList.remove('frantic-gift-item');
    var f = item.querySelector('.frantic-gift-flag');
    if (f) { f.remove(); }
  }

  function decorate() {
    if (!giftKey) {
      document.querySelectorAll('.frantic-gift-item').forEach(clearFlag);
      return;
    }
    document.querySelectorAll('[data-js-cart-item]').forEach(function (item) {
      if (item.getAttribute('data-id') !== giftKey) {
        if (item.classList.contains('frantic-gift-item')) { clearFlag(item); }
        return;
      }
      if (CONFIG.behaviour.lockQuantity) { item.classList.add('frantic-gift-item'); }
      if (!item.querySelector('.frantic-gift-flag')) {
        var anchor = item.querySelector('.cart-item__title');
        if (anchor && anchor.parentNode) {
          var flag = document.createElement('span');
          flag.className = 'frantic-gift-flag';
          flag.innerHTML =
            '<span class="frantic-gift-flag__tag">' + escapeHtml(fill(CONFIG.text.cartTag)) + '</span>' +
            ICON_GIFT +
            '<span class="frantic-gift-flag__label">' + escapeHtml(fill(CONFIG.text.cartLabel)) + '</span>';
          anchor.parentNode.insertBefore(flag, anchor);
        }
      }
    });
  }

  /* ================================================================
     9. ENGINE
     ================================================================ */
  var busy = false;
  var queued = false;
  var syncTimer = null;
  var settleTimer = null;
  var giftUnavailable = false;   // set on 422 (sold out) - stop asking

  function findGiftLines(cart) {
    var out = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === Number(CONFIG.variantId)) {
        out.push(cart.items[i]);
      }
    }
    return out;
  }

  function isDiscounted(line) {
    var orig = (typeof line.original_line_price === 'number') ? line.original_line_price : null;
    var fin = (typeof line.final_line_price === 'number') ? line.final_line_price : line.line_price;
    if (orig !== null && fin < orig) { return true; }
    return fin === 0;
  }

  function hasProps(line) {
    var p = line.properties;
    if (!p) { return false; }
    for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) { return true; } }
    return false;
  }

  /* Pick the line to KEEP: the discounted one (no price flicker for the
     customer), else a plain one, else the first. */
  function pickKeeper(lines) {
    var i;
    for (i = 0; i < lines.length; i++) { if (isDiscounted(lines[i])) { return lines[i]; } }
    for (i = 0; i < lines.length; i++) { if (!hasProps(lines[i])) { return lines[i]; } }
    return lines[0];
  }

  function baseTotal(cart, giftLines) {
    var skip = {};
    for (var g = 0; g < giftLines.length; g++) { skip[giftLines[g].key] = true; }
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (skip[it.key]) { continue; }
      sum += (typeof it.final_line_price === 'number') ? it.final_line_price : it.line_price;
    }
    return sum;
  }

  function removeLines(lines) {
    return lines.reduce(function (chain, line) {
      /* forensics: whoever created this duplicate is identified by its
         properties - always logged, even without debug mode */
      try {
        if (window.console) {
          console.info('[frantic-gift] removing duplicate gift line',
            JSON.stringify({ key: line.key, qty: line.quantity, properties: line.properties || {} }));
        }
      } catch (e) {}
      return chain.then(function () {
        return post('cart/change.js', { id: line.key, quantity: 0 });
      });
    }, Promise.resolve());
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { sync(); },
      typeof delay === 'number' ? delay : CONFIG.timing.debounce);
  }

  /* Own timer so scheduleSync can never cancel it: after every write of
     ours, verify once more - catches anything that lands mid-flight. */
  function scheduleSettle() {
    if (!(CONFIG.timing.settle > 0)) { return; }
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () { sync(); }, CONFIG.timing.settle);
  }

  function addGift() {
    /* Race guard: someone else (an app, native discount auto-add, a
       second tab) may be adding the gift right now. Wait a beat,
       re-read, and only add if the cart is still without one. */
    return new Promise(function (resolve) {
      setTimeout(resolve, CONFIG.timing.preAddCheck);
    }).then(function () {
      return getCart();
    }).then(function (cart) {
      if (findGiftLines(cart).length > 0) {
        log('pre-add check: gift appeared meanwhile - adopting, not adding');
        queued = true;
        return null;
      }

      /* FRANTIC FIX (2026-08): the guard above only asked "is a gift already
         here?". It never re-asked "does the cart still qualify?".

         sync() reads the total, decides to add, and then this function waits
         300 ms before writing. If the customer removes an item inside that
         window - entirely normal, the qty stepper is right there - the gift
         was added anyway, and only removed again about 900 ms later by the
         next sync. The customer saw "Gift unlocked" flash and disappear, and
         a fast express checkout in between shipped the pouch for free.

         The cart we just fetched is current, so re-checking is free. */
      var freshBase = baseTotal(cart, findGiftLines(cart));
      if (freshBase < THRESHOLD) {
        log('pre-add check: cart dropped to', freshBase, 'below', THRESHOLD, '- not adding');
        queued = true;
        return null;
      }

      return post('cart/add.js', {
        items: [{ id: CONFIG.variantId, quantity: CONFIG.quantity }]
      }).then(function (res) {
        if (res && res.status && res.status !== 200) {
          if (res.status === 422) {
            giftUnavailable = true;
            log('gift unavailable - no further attempts this page load');
            /* FRANTIC FIX: 422 means the pouch is sold out or unpurchasable.
               Until now only this internal flag was set, while the promo
               blocks kept advertising "free over EUR 200". The customer then
               reached the threshold, received nothing, and saw no explanation.
               Hide the promise instead of leaving a claim we cannot honour. */
            hidePromos();
          }
          throw new Error(res.description || res.message || 'add failed');
        }
        var added = res && res.items && res.items[0];
        giftKey = added ? added.key : null;

        /* FRANTIC FIX 2026-08: erst pruefen, dann "Free" behaupten.

           Bisher wurde der Toast "Gift unlocked ... on me" und die Plakette
           "Free" gesetzt, sobald cart/add.js mit 200 antwortete. Ein Add
           gelingt aber IMMER - unabhaengig davon, ob Shopify den automatischen
           Rabatt anwendet. Der Rabatt haengt an der Sammlung
           "SYSTEM - Gift Eligible", die Schwelle wird hier dagegen aus der
           Gesamtsumme gerechnet. Fallen die beiden auseinander, sah der Kunde
           "Free" und zahlte trotzdem.

           isDiscounted() existierte bereits, wurde aber nur zum Aussortieren
           von Dubletten benutzt. Jetzt wird der Warenkorb nach dem Schreiben
           erneut gelesen und die Zeile geprueft. Ist sie nicht rabattiert,
           wird sie wieder entfernt und nichts versprochen.

           Bewusst konservativ: im Zweifel lieber kein Geschenk anzeigen als
           ein falsches Versprechen. */
        return getCart().then(function (fresh) {
          var lines = findGiftLines(fresh);
          var line = lines.length ? pickKeeper(lines) : null;

          if (line && !isDiscounted(line)) {
            log('gift added but NOT discounted - rolling back');
            return post('cart/change.js', { id: line.key, quantity: 0 })
              .then(function () {
                giftKey = null;
                return refreshCartUI();
              })
              .then(function () { decorate(); });
          }

          if (line) { giftKey = line.key; }
          setAttributesAsync(markedPatch());
          toastAdded(added ? added.image : null);
          return refreshCartUI().then(function () {
            decorate();
            scheduleSettle();
          });
        });
      });
    }).catch(function (e) { log('add failed', e); });
  }

  function markedPatch()  { var o = {}; o[ATTR_ADDED] = '1'; o[ATTR_DECLINED] = ''; return o; }
  function clearedPatch() { var o = {}; o[ATTR_ADDED] = '';  o[ATTR_DECLINED] = ''; return o; }

  function sync() {
    if (busy) { queued = true; return Promise.resolve(); }
    busy = true;

    return getCart().then(function (cart) {
      var giftLines = findGiftLines(cart);
      var base = baseTotal(cart, giftLines);
      var qualifies = base >= THRESHOLD;
      var attrs = cart.attributes || {};
      var wasAdded = String(attrs[ATTR_ADDED] || '') === '1';
      var declined = CONFIG.behaviour.respectManualRemove &&
                     String(attrs[ATTR_DECLINED] || '') === '1';

      var gift = giftLines.length ? pickKeeper(giftLines) : null;
      giftKey = gift ? gift.key : null;

      log('base', base, 'threshold', THRESHOLD, 'qualifies', qualifies,
          'giftLines', giftLines.length, 'wasAdded', wasAdded, 'declined', declined);

      /* --- duplicates: keep the discounted line, drop the rest --- */
      if (giftLines.length > 1) {
        var extras = giftLines.filter(function (l) { return l.key !== gift.key; });
        return removeLines(extras)
          .then(function () { return refreshCartUI(); })
          .then(function () { queued = true; scheduleSettle(); })
          .catch(function (e) { log('collapse failed', e); });
      }

      /* --- gift is in the cart --- */
      if (gift) {
        if (!qualifies && CONFIG.behaviour.autoRemove) {
          return post('cart/change.js', { id: gift.key, quantity: 0 }).then(function () {
            giftKey = null;
            setAttributesAsync(clearedPatch());
            toastRemoved(gift.image);
            return refreshCartUI().then(decorate);
          });
        }
        if (gift.quantity !== CONFIG.quantity) {
          log('gift quantity', gift.quantity, '-> resetting to', CONFIG.quantity);
          return post('cart/change.js', { id: gift.key, quantity: CONFIG.quantity })
            .then(function () { return refreshCartUI(); })
            .then(function () { decorate(); scheduleSettle(); });
        }
        if (!wasAdded && qualifies) { setAttributesAsync(markedPatch()); }
        decorate();
        return null;
      }

      /* --- gift is NOT in the cart --- */
      if (qualifies && wasAdded && CONFIG.behaviour.respectManualRemove) {
        return setAttributes({ _frantic_gift: '', _frantic_gift_declined: '1' }).then(decorate);
      }
      if (qualifies && !declined && !giftUnavailable && CONFIG.behaviour.addToCart) {
        return addGift();
      }
      if (!qualifies && (wasAdded || declined)) { setAttributesAsync(clearedPatch()); }
      decorate();
      return null;
    })
    .catch(function (e) { log('sync error', e); })
    .then(function () {
      busy = false;
      if (queued) { queued = false; scheduleSync(20); }
    });
  }

  /* ================================================================
     10. OBSERVERS (fetch + XHR + theme events + cart re-renders)
     ================================================================ */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i;

  function isCartWrite(url) {
    if (!url) { return false; }
    try { return CART_WRITE.test(String(url)); } catch (e) { return false; }
  }

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url);
      var hit = isCartWrite(url);
      var out = origFetch.apply(this, arguments);
      if (hit) { out.then(function () { scheduleSync(CONFIG.timing.debounce); }, function () {}); }
      return out;
    };
  }

  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__franticCartWrite = isCartWrite(url);
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__franticCartWrite) {
        this.addEventListener('load', function () { scheduleSync(CONFIG.timing.debounce); });
      }
      return origSend.apply(this, arguments);
    };
  }

  ['krown:cart:update', 'krown:cart:add', 'cart-updated'].forEach(function (evt) {
    document.addEventListener(evt, function () { scheduleSync(CONFIG.timing.debounce); });
  });

  function observeCart() {
    var target = document.getElementById('AjaxCartForm');
    if (!target || target.__franticObserved) { return; }
    target.__franticObserved = true;
    new MutationObserver(function () { decorate(); }).observe(target, { childList: true, subtree: true });
  }

  /* ================================================================
     11. PROMO BLOCKS (product page + homepage) - copy only
     ================================================================ */
  function promoNodes(suffix) {
    return document.querySelectorAll('[class^="micro-promo-"][class$="-' + suffix + '"]');
  }

  var promoPriceDone = false;

  function updatePromoPrice() {
    if (promoPriceDone || !CONFIG.promo.updatePrice) { return; }
    promoPriceDone = true;
    rawFetch(ROOT + 'products/' + CONFIG.promo.handle + '.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || typeof p.price !== 'number') { return; }
        var label = formatMoney(p.price, MONEY.code);
        promoNodes('was').forEach(function (el) { el.textContent = label; });
      })
      .catch(function (e) { promoPriceDone = false; log('promo price failed', e); });
  }

  /* FRANTIC FIX: called when the gift turns out to be unpurchasable (422).
     Hides every promo block rather than leaving copy that promises something
     the shop cannot deliver. Uses the same node lookup as updatePromos(), so
     it stays in sync with whatever markup frantic-gift-promo.liquid renders. */
  function hidePromos() {
    /* "-container" is the outermost wrapper of a promo block, see
       snippets/frantic-gift-promo.liquid. Hiding it removes the whole claim
       rather than leaving an empty frame behind. */
    var boxes = promoNodes('container');
    if (!boxes.length) { boxes = promoNodes('box'); }
    boxes.forEach(function (el) { el.style.display = 'none'; });
    log('promo blocks hidden - gift unavailable (' + boxes.length + ')');
  }

  function updatePromos() {
    if (!CONFIG.promo.enabled) { return; }
    if (giftUnavailable) { hidePromos(); return; }
    var tags = promoNodes('promo-tag');
    if (!tags.length) { return; }
    var label = fill(CONFIG.promo.label);
    tags.forEach(function (el) {
      if (el.textContent.trim() !== label) { el.textContent = label; }
    });
    promoNodes('now').forEach(function (el) {
      if (el.textContent.trim() !== CONFIG.promo.freeLabel) { el.textContent = CONFIG.promo.freeLabel; }
    });
    updatePromoPrice();
  }

  /* ================================================================
     12. BOOT + DEBUG HANDLE
     ================================================================ */
  function boot() {
    injectStyles();
    observeCart();
    decorate();
    updatePromos();
    scheduleSync(CONFIG.timing.boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    observeCart();
    decorate();
    updatePromos();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { scheduleSync(CONFIG.timing.boot); }
  });

  window.FranticAutoGift = {
    config: CONFIG,
    currency: MONEY,
    threshold: THRESHOLD,
    thresholdLabel: THRESHOLD_LABEL,
    sync: function () { return sync(); },
    reset: function () {
      return setAttributes({ _frantic_gift: '', _frantic_gift_declined: '' })
        .then(function () { return sync(); });
    },
    demo: function (which) {
      if (which === 'removed') { toastRemoved(); } else { toastAdded(); }
    }
  };

})();
